export default __webpack_public_path__ + "assets/malaysia-flag.png";